var _filter, _rect, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 600,
    viewBox: "0 0 1200 600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0A1929",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#1E3A8A",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1E40AF",
      stopOpacity: 1
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "glow2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 600,
    fill: "url(#bgGradient)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#00BFFF",
    strokeWidth: 1,
    opacity: 0.3,
    filter: "url(#glow2)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 100,
    x2: 1200,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 200,
    x2: 1200,
    y2: 200
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 300,
    x2: 1200,
    y2: 300
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 400,
    x2: 1200,
    y2: 400
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 500,
    x2: 1200,
    y2: 500
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 0,
    x2: 100,
    y2: 600
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 0,
    x2: 200,
    y2: 600
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 0,
    x2: 300,
    y2: 600
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 0,
    x2: 400,
    y2: 600
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 0,
    x2: 500,
    y2: 600
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 0,
    x2: 600,
    y2: 600
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 0,
    x2: 700,
    y2: 600
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 0,
    x2: 800,
    y2: 600
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 0,
    x2: 900,
    y2: 600
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 0,
    x2: 1000,
    y2: 600
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 0,
    x2: 1100,
    y2: 600
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 1200,
    y2: 600
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 0,
    x2: 0,
    y2: 600
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#00BFFF",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 300,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 400,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 500,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 100,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 700,
    cy: 200,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 300,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 900,
    cy: 400,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 500,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1100,
    cy: 100,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 500,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 400,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 300,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 200,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 100,
    r: 3
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#00BFFF",
    opacity: 0.1,
    fontFamily: "monospace",
    fontSize: 12
  }, /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 50
  }, "10101010"), /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 150
  }, "01010101"), /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 250
  }, "11001100"), /*#__PURE__*/React.createElement("text", {
    x: 350,
    y: 350
  }, "00110011"), /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 450
  }, "11110000"), /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 550
  }, "00001111"), /*#__PURE__*/React.createElement("text", {
    x: 650,
    y: 50
  }, "10101010"), /*#__PURE__*/React.createElement("text", {
    x: 750,
    y: 150
  }, "01010101"), /*#__PURE__*/React.createElement("text", {
    x: 850,
    y: 250
  }, "11001100"), /*#__PURE__*/React.createElement("text", {
    x: 950,
    y: 350
  }, "00110011"), /*#__PURE__*/React.createElement("text", {
    x: 1050,
    y: 450
  }, "11110000"), /*#__PURE__*/React.createElement("text", {
    x: 1150,
    y: 550
  }, "00001111"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBg);
export default __webpack_public_path__ + "static/media/hero-bg.2c95daf88ef486b3c8865327ebbc2be4.svg";
export { ForwardRef as ReactComponent };